import { useAppDispatch, useAppSelector } from "../../../../utils/hooks";
import { useTheme } from "../../../../context/ThemeProvider";
import { RxCross2 } from "react-icons/rx";
import { updateSendMessageData } from "../../../../store/Slices/SendMessageSlice";

export default function SelectedEditMessage() {
  const dispatch = useAppDispatch();
  const messageData = useAppSelector((state) => state.SendMessageData);
  const messageList = useAppSelector((state) => state.MessageList);
  // @ts-ignore
  const { theme } = useTheme();
  const editId = Number(messageData.edit_message_id) || 0;
  const editing = editId > 0;

  const original =
    messageList.message_list?.Records?.find((m) => m.message_id == editId) ||
    messageList.pinned_messages?.Records?.find((m) => m.message_id == editId);

  // Prefer stored snapshot so typing in the input does not change the preview
  const originalText = (
    messageData.edit_message_original ||
    original?.message_content ||
    ""
  ).trim();

  if (!editing) return null;

  return (
    <div
      className={`absolute bottom-16 left-2 right-2 z-10 overflow-hidden rounded-2xl border bg-primary transition-all duration-300 ${
        theme === "dark" ? "border-[#EEEEEE14]" : "border-black/[0.06]"
      }`}
    >
      <div className="relative flex min-h-[52px] min-w-0 items-stretch">
        <div
          className="my-2.5 ml-2.5 w-[3px] shrink-0 self-stretch rounded-full bg-themeColor"
          aria-hidden
        />
        <RxCross2
          onClick={() => {
            dispatch(
              updateSendMessageData({
                edit_message_id: 0,
                edit_message_original: "",
                message: "",
                message_type: "",
              }),
            );
          }}
          className="absolute right-2 top-1/2 z-10 h-8 w-8 -translate-y-1/2 cursor-pointer rounded-full bg-secondary p-2"
        />
        <div className="flex min-w-0 flex-1 items-center px-3 py-3 pr-12">
          <div className="line-clamp-2 break-all text-sm leading-snug text-darkText">
            {originalText || "…"}
          </div>
        </div>
      </div>
    </div>
  );
}
